<div class="custom-table overflow-x-auto">
	<table class="mat-elevation-z8 bg-transparent w-full relative">
		<thead class="bg-light">
			<tr class="border-b-[1px] border-secondry-color-Gray">
				<td
					class="text-font-14 leading-[22px] text-medium-gray py-[14px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap w-[16%]"
				>
					{{ 'REVIEWS.PRODUCT_NAME' | translate }}
				</td>

				<td
					class="text-font-14 leading-[22px] text-medium-gray py-[14px] max-mobile:px-padding-mobile-14 whitespace-nowrap w-[16%]"
				>
					{{ 'REVIEWS.CLIENT_NAME' | translate }}
				</td>

				<td
					class="text-font-14 leading-[22px] text-medium-gray py-[14px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap w-[16%]"
				>
					{{ 'REVIEWS.DATE' | translate }}
				</td>
				<td
					class="text-font-14 leading-[22px] text-medium-gray py-[14px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap w-[16%]"
				>
					{{ 'REVIEWS.RATING' | translate }}
				</td>
				<td
					class="text-font-14 leading-[22px] text-medium-gray py-[14px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap w-[16%]"
				>
					{{ 'REVIEWS.COMMENT' | translate }}
				</td>
				<td
					class="text-font-14 leading-[22px] text-medium-gray py-[14px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap w-[16%]"
					*ngIf="reviewFilter?.activeTab == 1"
				>
					{{ 'ACTIONS.ACTION' | translate }}
				</td>
				<td
					class="text-font-14 leading-[22px] text-medium-gray py-[14px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap w-[16%]"
					*ngIf="reviewFilter?.activeTab == 2"
				>
					{{ 'REVIEWS.PERFORMED_BY' | translate }}
				</td>
			</tr>
		</thead>
		<tbody class="bg-grey-background">
			<tr
				*ngFor="
					let review of reviews
						| paginate
							: {
									itemsPerPage: reviewFilter?.paging?.pageSize,
									currentPage: reviewFilter?.paging?.pageNumber,
									totalItems: totalCount
							  };
					let indx = index
				"
			>
				<td
					class="cursor-pointer text-font-16 leading-[22px] text-medium-gray bg-grey-background py-[6px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
				>
					<span
						class="flex items-center rtl:max-mobile:ml-8 ltr:max-mobile:mr-8"
					>
						<a
							[routerLink]="
								'/layout/store/products/product-details/' + review?.productId
							"
							class="whitespace-normal text-dark-grey break-all"
						>
							{{
								translate.currentLang == 'en'
									? review?.productName?.en
									: review?.productName?.ar
							}}
						</a>
						<img
							*ngIf="review?.hasImages"
							class="mx-2"
							src="./assets/images/Attachmenent.svg"
							alt=""
						/>
					</span>
				</td>

				<td
					class="text-font-16 leading-[22px] text-medium-gray bg-grey-background py-[6px] max-mobile:px-padding-mobile-14 whitespace-nowrap font-Poppins-regular"
				>
					<a
						[routerLink]="'/layout/clients/client-profile/' + review?.clientId"
						class="text-font-16 text-dark-grey max-mobile:text-font-12"
					>
						{{ review?.clientName }}
					</a>
				</td>
				<td
					class="text-font-16 leading-[22px] text-dark-grey bg-grey-background py-[6px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
				>
					<p>{{ review?.reviewDateTime | date : 'dd/MM/yyyy' : 'UTC' }}</p>
					<p>{{ review?.reviewDateTime | date : 'hh:mm a' : 'UTC' }}</p>
				</td>
				<td
					class="flex items-center text-font-16 leading-[22px] text-dark-grey bg-grey-background py-[12px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
				>
					<img
						*ngFor="
							let item of [].constructor(review?.rating ? review.rating : null)
						"
						src="./assets/images/star.svg"
						alt=""
					/>
					<span>{{ review?.rating ? review.rating : null }}</span>
				</td>
				<td
					class="text-font-16 leading-[22px] text-dark-grey bg-grey-background py-[6px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
				>
					<span *ngIf="reviewFilter?.activeTab == 2">
						<app-status
							[enumData]="ReviewStatusEnum"
							[statusValue]="review?.reviewStatus"
						></app-status>
					</span>
					<!-- <p>{{ review?.comment }}</p> -->
					<p class="text-dark-grey">
						{{ review?.comment | slice : 0 : 15 }}
						{{ review.comment.length > 15 ? '...' : '' }}
					</p>
				</td>
				<td
					*ngIf="reviewFilter?.activeTab == 1"
					class="text-font-16 leading-[22px] text-medium-gray bg-grey-background py-[6px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
				>
					<div class="flex">
						<button
							(click)="changeReviewStatus(review?.id, 2)"
							class="p-[10px] bg-gradient text-off-white rounded-6px text-font-14"
						>
							{{ 'ACTIONS.CONFIRM' | translate }}
						</button>
						<button
							(click)="changeReviewStatus(review?.id, 3)"
							class="border-[1px] border-secondry-color-Gray p-[10px] text-dark-grey text-font-14 rounded-6px mx-[6px]"
						>
							{{ 'ACTIONS.CANCEL' | translate }}
						</button>
					</div>
				</td>
				<td
					*ngIf="reviewFilter?.activeTab == 2"
					class="text-font-16 leading-[22px] text-dark-grey bg-grey-background py-[6px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
				>
					<p>{{ review?.actionByUserName }}</p>
					<p>{{ review?.actionDate | date : 'dd/MM/yyyy' : 'UTC' }}</p>
				</td>
				<td>
					<button (click)="getReviewDetails(review.id)">
						<img
							[src]="'assets/images/view.svg'"
							alt=""
							class="inline-block cursor-pointer w-[16px]"
						/>
					</button>
				</td>
			</tr>
		</tbody>
	</table>
</div>
